import Annotation from './Annotation';

export default Annotation;